import { render, staticRenderFns } from "./UiInputText.vue?vue&type=template&id=9ff4e284&scoped=true&"
import script from "./UiInputText.vue?vue&type=script&lang=js&"
export * from "./UiInputText.vue?vue&type=script&lang=js&"
import style0 from "./UiInputText.vue?vue&type=style&index=0&id=9ff4e284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff4e284",
  null
  
)

export default component.exports